import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "@/pages/Landing";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminQuotes from "@/pages/admin/AdminQuotes";
import AdminQuoteDetail from "@/pages/admin/AdminQuoteDetail";
import AdminSettings from "@/pages/admin/AdminSettings";
import RequireAdmin from "@/components/admin/RequireAdmin";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App bg-[#0a0a0a] text-white min-h-screen">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route
            path="/admin"
            element={
              <RequireAdmin>
                <AdminQuotes />
              </RequireAdmin>
            }
          />
          <Route
            path="/admin/q/:id"
            element={
              <RequireAdmin>
                <AdminQuoteDetail />
              </RequireAdmin>
            }
          />
          <Route
            path="/admin/settings"
            element={
              <RequireAdmin>
                <AdminSettings />
              </RequireAdmin>
            }
          />
        </Routes>
      </BrowserRouter>
      <Toaster
        position="bottom-center"
        theme="dark"
        toastOptions={{
          style: {
            background: "#121212",
            color: "#fff",
            border: "1px solid rgba(255,255,255,0.08)",
            borderRadius: 0,
          },
        }}
      />
    </div>
  );
}

export default App;
